export type AccountingExportSourceFilter = 'all' | 'booking' | 'standalone';

export type AccountingExportChannelFilter = 'sales' | 'purchases';

export type AccountingExportSource = 'BookingSnapshot' | 'SalesInvoice' | 'PurchaseInvoice';

export type AccountingExportChannel = 'Sales' | 'Purchases';

export type AccountingExportEligibilityStatus = 'Eligible' | 'Blocked';

export const accountingExportErrorCodes = [
  'AccountingExport.ValidationFailed',
  'AccountingExport.EligibilityBlocked',
  'AccountingExport.DuplicateExport',
  'AccountingExport.GenerationFailed',
] as const;

export type AccountingExportErrorCode = (typeof accountingExportErrorCodes)[number];

export interface AccountingExportBlockingReason {
  code: string;
  message: string;
}

export interface AccountingExportDocumentItem {
  documentId: string;
  source: AccountingExportSource;
  channel: AccountingExportChannel;
  documentType: string;
  scheme: string | null;
  companyId: number;
  issueDate: string;
  saleDate: string | null;
  taxDate: string;
  number: string;
  offerName: string | null;
  bookingDateFrom: string | null;
  bookingDateTo: string | null;
  bookingContextLabel: string | null;
  net: number;
  vat: number;
  gross: number;
  sentToAccountingAtUtc: string | null;
  exportEligibilityStatus: AccountingExportEligibilityStatus;
  blockingReasons: AccountingExportBlockingReason[];
}

export interface AccountingExportItemsQuery {
  companyId: number;
  dateFrom?: string;
  dateTo?: string;
  source?: AccountingExportSourceFilter;
  channel?: AccountingExportChannelFilter;
  sentToAccounting?: boolean;
}

export interface AccountingExportFileQuery {
  companyId: number;
  dateFrom: string;
  dateTo: string;
}

export interface AccountingExportFileQueryWithFilename extends AccountingExportFileQuery {
  filename: string;
}

export interface AccountingExportProblemDetails {
  title?: string;
  detail?: string;
  status?: number;
  code?: string;
  errorCode?: string;
  errors?: Record<string, string[]>;
}

